module.exports = __webpack_public_path__ + "unityPostit.svg?38670b337d250695accf70401d80c098";